import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { ConfigsLoaderService } from './config-loader.service';
import { PPApproversDto, PPApproversPaged, PPFileUserNotificationDto, ResendNotificationDto, PPFilesDto, PPFolderMetaData, PPCheckIfFileExists, PPFileApproverGridItemDto, PPDeleteApprover, PPFilesReportDto, PPFileVersionsDto, PpDisclaimerFilterDto, PpDisclaimerPaged, SaveppDisclaimerDto, PpDisclaimerDto, VisualizationPagedDto, PPVisualizationFilterDto, ApproverPagedDto, PPApproverFilterDto, PPApproverUpdate } from 'app/models/pp-file-directory/pp-file-directory.model';
import { PPFileCreateFolderDto, PPFolderAndFilesDto, PPFolderAndFilesFilterDto, PPFolderPaged } from 'app/models/pp-file-directory/pp-file-directory.model';
import { PPApprovalStatusEnum, PPNotificationStatusEnum } from 'app/enums/pp-file-directory.enum';
import { AssignedTeamItem } from 'app/models/item.inferface';
import { FileDto } from 'app/models/file';


@Injectable({
    providedIn: 'root'
})

export class PPFileDirectoryService {

    private readonly useMockData = true;
    private readonly apiEndpoint: string;

    constructor(
        private httpClient: HttpClient,
        private config: ConfigsLoaderService,
    ) {
        this.apiEndpoint = this.config.apiUrl;
    }

    getRootFolderInitialized(): Observable<any>{
        return this.httpClient.post<any>(`${this.apiEndpoint}/PPFolderAndFiles/CreateRootFolder`, {name: 'rootFolder'});
    }

    getRootFolderId(): Observable<number>{
        return this.httpClient.get<number>(`${this.apiEndpoint}/PPFolderAndFiles/GetRootFolder`);
    }

    // TODO: change to PPFolderMetaData when API ready
    getPaged(filter: PPFolderAndFilesFilterDto): Observable<PPFolderMetaData> {
        return this.httpClient.post<PPFolderMetaData>(`${this.apiEndpoint}/PPFolderAndFiles/getPaged/`, filter);
    }

    getPagedApprovers(filter: PPFolderAndFilesFilterDto): Observable<PPApproversPaged> {
        if (this.useMockData) { 
        
            const item: PPApproversDto[] = [{
                id: 1,
                user: "test1",  
                group:'test1',
                approvalDate: new Date(),  
                noticeApprove:'test1',
                approval:'Aprobado',
                action:'' 
            },
            {
                id: 2,
                user: "test2",  
                group:'test2',
                approvalDate: new Date(),  
                noticeApprove:'test2',
                approval:'Rechazado',
                action:'' 
            },
            {
                id: 3,
                user: "test3",  
                group:'test3',
                approvalDate: new Date(),  
                noticeApprove:'test3',
                approval:'Pendiente',
                action:'' 
            }]
            const foo: PPApproversPaged = {
                currentPage: 1,
                pageCount: 1,
                pageSize: 10,
                rowCount: 1,
                results: item
            }
            return of(foo);
        }
        // return this.httpClient.post<PPFolderPaged>(`${this.apiEndpoint}/PPFolderAndFiles/getPaged/`, filter);
    }
    
    createFolder(folder: PPFileCreateFolderDto): Observable<any>{
        return this.httpClient.post<any>(`${this.apiEndpoint}/PPFolderAndFiles/CreateFolder`, folder);
    }

    checkFiles(files: PPCheckIfFileExists): Observable<{file: FileDto[]}>{
        return this.httpClient.post<{file: FileDto[]}>(`${this.apiEndpoint}/PPFolderAndFiles/ExistsPPFile`, files);
    }

    uploadFile(files: PPFilesDto[]): Observable<void>{
        return this.httpClient.post<void>(`${this.apiEndpoint}/PPFolderAndFiles/SavePPFile`, files);
    }

    editTags(files: PPFilesDto[]): Observable<void>{
        return this.httpClient.post<void>(`${this.apiEndpoint}/PPFolderAndFiles/SavePPFile`, files);
    }

    getUsersAndGroups(description:string): Observable<AssignedTeamItem[]>{
        return this.httpClient.get<AssignedTeamItem[]>(`${this.apiEndpoint}/PPFolderAndFiles/GetUserAndUserGroup?description=${description}`);
    }

    getUsersAndGroupApprovers(description:string): Observable<AssignedTeamItem[]>{
        return this.httpClient.get<AssignedTeamItem[]>(`${this.apiEndpoint}/PPFolderAndFiles/GetUserApprovers?description=${description}`);
    }

    getFileById(id:number){
        return this.httpClient.get<any>(`${this.apiEndpoint}/PPFolderAndFiles/${id}`);
    }

    getNotificationUsers(id:number){
        return this.httpClient.get<PPFileUserNotificationDto[]>(`${this.apiEndpoint}/PPFolderAndFiles/ResendReadNotification?ppFileId=${id}`);
    }

    getUserApprovers(id:number){
        return this.httpClient.get<PPFileApproverGridItemDto[]>(`${this.apiEndpoint}/PPFolderAndFiles/GetApprovers?id=${id}`);
    }

    deleteApprover(approverDelete: PPDeleteApprover): Observable<any> {
        return this.httpClient.delete(`${this.apiEndpoint}/PPFolderAndFiles/Approvers`, {body: approverDelete} );
    }

    saveApprovers(approvers: PPFilesDto[]): Observable<void>{
        return this.httpClient.post<void>(`${this.apiEndpoint}/PPFolderAndFiles/SavePPFile`, approvers);
    }

    generatePPReport(data: PPFilesReportDto): Observable<void>{
        return this.httpClient.post<void>(`${this.apiEndpoint}/PPFolderAndFiles/GenerateReport`, data);
    }

    deleteFile(id:number){
        return this.httpClient.delete(`${this.apiEndpoint}/PPFolderAndFiles/PPFile?ppFileId=${id}`);
    }

    deleteFolder(id:number){
        return this.httpClient.delete(`${this.apiEndpoint}/PPFolderAndFiles/Folders?ppFolderId=${id}`);
    }
    
    generateNotificatedReport(data: {typeId: number, ppFileId: number}): Observable<void>{
        return this.httpClient.post<void>(`${this.apiEndpoint}/PPFolderAndFiles/GenerateNotificationReport`, data);
    }

    getPreviousVersions(ppFileId: number): Observable<PPFileVersionsDto[]>{
        return this.httpClient.get<PPFileVersionsDto[]>(`${this.apiEndpoint}/PPFolderAndFiles/PPFileVersion?ppFileId=${ppFileId}`);
    }

    getDisclaimersPaged(data: PpDisclaimerFilterDto): Observable<PpDisclaimerPaged>{
        return this.httpClient.post<PpDisclaimerPaged>(`${this.apiEndpoint}/PPFolderAndFiles/GetDisclaimer`, data);
    }

    saveDisclaimer(data: SaveppDisclaimerDto[]){
        return this.httpClient.post(`${this.apiEndpoint}/PPFolderAndFiles/SaveDisclaimer`, data);
    }

    getDisclaimerById(id: number): Observable<PpDisclaimerDto>{
        return this.httpClient.get<PpDisclaimerDto>(`${this.apiEndpoint}/PPFolderAndFiles/GetDisclaimer?iD=${id}`);
    }

    existsDisclaimer(ppFileId:number): Observable<PpDisclaimerDto>{
        return this.httpClient.get<PpDisclaimerDto>(`${this.apiEndpoint}/PPFolderAndFiles/ExistsDisclaimer?ppFileId=${ppFileId}`);
    }

    existsDisclaimerPost(ppFileIds:number[]): Observable<PpDisclaimerDto[]>{
        return this.httpClient.post<PpDisclaimerDto[]>(`${this.apiEndpoint}/PPFolderAndFiles/ExistsDisclaimer`, ppFileIds);
    }

    getApproverPaged(data: PPApproverFilterDto): Observable<ApproverPagedDto>{
        return this.httpClient.post<ApproverPagedDto>(`${this.apiEndpoint}/PPFolderAndFiles/GetApprovals`, data);
        // const mock: ApproverPagedDto = {
        //     currentPage: 1,
        //     firstRowOnPage: 1,
        //     pageCount: 10,
        //     pageSize: 10,
        //     results: [{
        //         id:10,
        //         fileName: 'test',
        //         ppFileId: 85,
        //         UserApproverId: 1,
        //         mimeType:'test',
        //         size:1,
        //         PPFileCreatedDate : null,
        //         PPFileMessageToApprovers: 'test',
        //         PPFileApprovalStatusId: 1
        //     },
        //     {
        //         id:20,
        //         fileName: 'test',
        //         ppFileId: 93,
        //         UserApproverId: 1,
        //         mimeType:'test',
        //         size:1,
        //         PPFileCreatedDate : null,
        //         PPFileMessageToApprovers: 'test',
        //         PPFileApprovalStatusId: 1
        //     },
        //     {
        //         id:1,
        //         fileName: 'test',
        //         ppFileId: 1,
        //         UserApproverId: 1,
        //         mimeType:'test',
        //         size:1,
        //         PPFileCreatedDate : null,
        //         PPFileMessageToApprovers: 'test',
        //         PPFileApprovalStatusId: 1
        //     },
        //     {
        //         id:2,
        //         fileName: 'test',
        //         ppFileId: 1,
        //         UserApproverId: 1,
        //         mimeType:'test',
        //         size:1,
        //         PPFileCreatedDate : null,
        //         PPFileMessageToApprovers: 'test',
        //         PPFileApprovalStatusId: 1
        //     },
        //     {
        //         id:3,
        //         fileName: 'test',
        //         ppFileId: 1,
        //         UserApproverId: 1,
        //         mimeType:'test',
        //         size:1,
        //         PPFileCreatedDate : null,
        //         PPFileMessageToApprovers: 'test',
        //         PPFileApprovalStatusId: 1
        //     }],
        //     rowCount: 10
        // };
        // return of(mock);
    }


    getVisulizationPaged(data: PPVisualizationFilterDto): Observable<VisualizationPagedDto>{
        return this.httpClient.post<VisualizationPagedDto>(`${this.apiEndpoint}/PPFolderAndFiles/NotificationVisualization`, data);
    }

    acceptanceFile(data: {ppFileId: number, userId: number}){
        return this.httpClient.post(`${this.apiEndpoint}/PPFolderAndFiles/AcceptanceFile`, data);
    }

    update(data: PPApproverUpdate){
        return this.httpClient.post(`${this.apiEndpoint}/PpFolderAndFiles/UpdateApprovals`, data);
    }
    
}
